module.exports = __webpack_public_path__ + "static/media/7ICJ2.61e3e67b.jpg";